import React from 'react'
import './css/HomeMap.css'

function HomeMap() {
  return (
    <div className='HomeMap'>
        <div className='map' style={{width: "100%"}}>
          <iframe 
            title='myLocation' width="100%" height="600" frameBorder="0" scrolling="no" 
            marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Plaza%20Catering%20Service%20Palakkad%20-%20Ponnani%20Rd%20Vaniyamkulam-I%20Palakkad%20Dist.+(Plaza%20Catering%20Service)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
            <a href="https://www.maps.ie/distance-area-calculator.html">measure distance on map</a>
          </iframe>
        </div>
    </div>
  )
}

export default HomeMap